module.exports = __webpack_public_path__ + "img/eng.8c1766ba.svg";